import React from "react";
import { SETTINGS } from "../../../config/settings";

function TitleHeader({ title }) {
  return (
    <div
      class="page-header"
      style={{ display: "flex", justifyContent: "center" }}
    >
      <div class="row ">
        <div class="col">
          <h3 class="page-title">{SETTINGS.fullTitle}</h3>
          <ul
            class="breadcrumb"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <li class="breadcrumb-item">
              <p class="breadcrumb-item active">{title}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default TitleHeader;
